import { Table, Button, Space, Row, Col, Modal, Typography, Card, Input, Tooltip, Dropdown, message, Menu } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  CopyOutlined,
  FileWordFilled,
  FileTextOutlined,
  ExportOutlined,
  MoreOutlined,
  SearchOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import CotizacionesForm from "./forms/CotizacionesForm";
import moment from "moment";
import { useAuth } from "../../layout/auth";

const CARD = {
  background: "#fff",
  border: "0.5px solid rgba(0,0,0,0.08)",
  borderRadius: "12px",
};

export default function CotizacionesList() {
  const [cotizacionesList, setCotizacionesList] = useState();
  const [currentData, setCurrentData] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredCotizaciones, setFilteredCotizaciones] = useState();
  const [loading, setLoading] = useState(false);
  const [showCotizacionesModal, setShowCotizacionModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCloneModal, setShowCloneModal] = useState(false);
  const [selectedCotizacion, setSelectedCotizacion] = useState();
  const [selectedRow, setSelectedRow] = useState();
  const [isNew, setIsNew] = useState(false);
  const searchInput = useRef(null);

  const auth = useAuth();

  const fetchCotizaciones = () => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/cotizaciones/view/list`)
      .then((res) => {
        setCotizacionesList(res.data);
        setCurrentData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCotizaciones();
  }, []);

  useEffect(() => {
    if (search) {
      const filtered = cotizacionesList?.filter((cotizacion) => {
        return cotizacion?.Solicitante?.toLowerCase().includes(search.toLowerCase());
      });
      setFilteredCotizaciones(filtered);
      setCurrentData(filtered || []);
    } else {
      setFilteredCotizaciones(cotizacionesList);
      setCurrentData(cotizacionesList || []);
    }
  }, [search, cotizacionesList]);

  const handleExport = () => {
    if (!currentData?.length) return message.warning("No hay datos para exportar");

    const headers = [
      "Solicitante",
      "Fecha de cotización",
      "Calle",
      "Número Exterior",
      "Número Interior",
      "Colonia",
      "Municipio",
      "Estado",
      "Código Postal",
      "Tensión",
      "Carga (kW)",
      "Precio",
    ];

    const escapeCSV = (val) => {
      if (val === null || val === undefined) return "";
      const s = String(val);
      if (s.includes(",") || s.includes('"') || s.includes("\n")) {
        return `"${s.replace(/"/g, '""')}"`;
      }
      return s;
    };

    const rows = currentData.map((v) => [
      escapeCSV(v.Solicitante),
      escapeCSV(v.FechaCotizacion ? moment(v.FechaCotizacion).format("DD/MM/YYYY") : ""),
      escapeCSV(v.Calle),
      escapeCSV(v.NumeroExterior),
      escapeCSV(v.NumeroInterior),
      escapeCSV(v.Colonia),
      escapeCSV(v.Municipio),
      escapeCSV(v.Estado),
      escapeCSV(v.CodigoPostal),
      escapeCSV(v.TipoTension),
      escapeCSV(v.CargaInstalada),
      escapeCSV(v.PrecioFinal),
    ]);

    const csvContent = [headers, ...rows].map((r) => r.join(",")).join("\n");
    const blob = new Blob(["\ufeff" + csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `cotizaciones_${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    message.success("Exportado correctamente");
  };

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Buscar ${title}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reiniciar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const handleCotizacionFormCancel = () => {
    setShowCotizacionModal(false);
  };

  const handleCotizacionFormOpen = (record) => {
    setSelectedCotizacion(record);
    setIsNew(!record);
    setShowCotizacionModal(true);
  };

  const handleDeleteCotizacion = (record) => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}/cotizaciones/${record.CotizacionID}`)
      .then((res) => {
        fetchCotizaciones();
        setSelectedRow(null);
        setShowDeleteModal(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCloneCotizacion = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}/cotizaciones/clone/${selectedRow}`)
      .then((res) => {
        fetchCotizaciones();
        setSelectedRow(null);
        setShowCloneModal(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const mobileMenuItems = [
    {
      key: "clonar",
      label: "Clonar",
      icon: <CopyOutlined />,
      onClick: () => {
        if (selectedRow) {
          setShowCloneModal(true);
        } else {
          message.error("Seleccione una cotización para clonar");
        }
      },
    },
    {
      key: "exportar",
      label: "Exportar",
      icon: <ExportOutlined />,
      onClick: handleExport,
    },
    {
      key: "eliminar",
      label: "Eliminar",
      icon: <DeleteOutlined />,
      danger: true,
      onClick: () => {
        if (auth.rol !== "director") {
          message.error("No tiene permisos para eliminar cotizaciones");
        } else if (selectedRow) {
          setShowDeleteModal(true);
        } else {
          message.error("Seleccione una cotización para eliminar");
        }
      },
    },
  ];

  const columns = [
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Solicitante</span>,
      dataIndex: "Solicitante",
      key: "Solicitante",
      sorter: (a, b) => (a.Solicitante || "").localeCompare(b.Solicitante || ""),
      ...getColumnSearchProps("Solicitante", "solicitante"),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Fecha de cotización</span>,
      dataIndex: "FechaCotizacion",
      key: "FechaCotizacion",
      sorter: (a, b) => moment(a.FechaCotizacion).unix() - moment(b.FechaCotizacion).unix(),
      render: (text, record) => (
        <Row gutter={[16, 0]}>
          <Col span={24}>
            <span>{moment(record.FechaCotizacion).format("DD/MM/YYYY")}</span>
          </Col>
          <Col span={24}>
            <span style={{ fontSize: "12px", color: "#8c8c8c" }}>{moment(record.FechaCotizacion).fromNow()}</span>
          </Col>
        </Row>
      ),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Domicilio</span>,
      render: (text, record) => (
        <Row gutter={[16, 0]}>
          <Col span={24}>
            <span>
              {record.Calle} {record.NumeroExterior}
              {record.NumeroInterior ? `, ${record.NumeroInterior}` : ""}
              {record.Colonia ? `, Col. ${record.Colonia}` : ""}
            </span>
          </Col>
          <Col span={24}>
            <span style={{ fontSize: "12px", color: "#8c8c8c" }}>
              {record.Municipio}, {record.Estado}, {record.CodigoPostal}
            </span>
          </Col>
        </Row>
      ),
      ...getColumnSearchProps("Calle", "domicilio"),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Tensión</span>,
      dataIndex: "TipoTension",
      key: "TipoTension",
      filters: [
        { text: "Baja Tensión", value: "Baja Tensión" },
        { text: "Media Tensión", value: "Media Tensión" },
      ],
      onFilter: (value, record) => record.TipoTension === value,
      sorter: (a, b) => (a.TipoTension || "").localeCompare(b.TipoTension || ""),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Carga (kW)</span>,
      dataIndex: "CargaInstalada",
      key: "CargaInstalada",
      align: "right",
      sorter: (a, b) => (a.CargaInstalada || 0) - (b.CargaInstalada || 0),
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Precio</span>,
      dataIndex: "PrecioFinal",
      key: "PrecioFinal",
      align: "right",
      sorter: (a, b) => (a.PrecioFinal || 0) - (b.PrecioFinal || 0),
      render: (text, record) => <span>{record.PrecioFinal.toLocaleString("es-MX", { style: "currency", currency: "MXN" })}</span>,
    },
    {
      title: <span style={{ fontWeight: 700, color: "#1890ff" }}>Acciones</span>,
      dataIndex: "Acciones",
      key: "Acciones",
      width: 150,
      render: (text, record) => {
        const wordStyle = {
          fontSize: "20px",
          color: "#27508F",
        };
        return (
          <Space size="small">
            <Button type="primary" icon={<EditOutlined />} onClick={() => handleCotizacionFormOpen(record)} />
            <Button
              type="default"
              icon={<FileWordFilled style={wordStyle} />}
              onClick={() => {
                axios({
                  method: "get",
                  url: `${process.env.REACT_APP_API_URL}/formatos/cotizacion/${record.CotizacionID}`,
                  responseType: "blob",
                })
                  .then((response) => {
                    const contentType = response.headers["content-type"];
                    const extension = contentType === "application/zip" ? "zip" : "docx";
                    const fileName = `cotizacion_${Date.now()}.${extension}`;
                    const blob = new Blob([response.data], { type: contentType });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                  })
                  .catch((err) => console.log(err));
              }}
            />
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              onClick={() => {
                setShowDeleteModal(true);
                setSelectedCotizacion(record);
              }}
              disabled={auth.rol !== "director"}
            />
          </Space>
        );
      },
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
      {/* ── Header card ── */}
      <div style={{ ...CARD, padding: 0 }}>
        {/* Title row */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            padding: "18px 20px 14px",
            borderBottom: "0.5px solid rgba(0,0,0,0.06)",
            flexWrap: "wrap",
          }}
        >
          {/* Icon badge */}
          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: 10,
              background: "rgba(24,144,255,0.08)",
              border: "0.5px solid rgba(24,144,255,0.18)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <FileTextOutlined style={{ fontSize: 17, color: "#1677ff" }} />
          </div>

          {/* Title + subtitle */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: "rgba(0,0,0,0.88)", lineHeight: 1.3 }}>
              Cotizaciones
            </div>
            <div style={{ fontSize: 12, color: "rgba(0,0,0,0.38)", marginTop: 1 }}>
              Gestión y elaboración de cotizaciones para clientes
            </div>
          </div>

          {/* Desktop actions */}
          <Space size={8} className="vf-desktop-actions" style={{ flexShrink: 0 }}>
            <Tooltip title="Nueva cotización">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ fontSize: 13, fontWeight: 500 }}
                onClick={() => handleCotizacionFormOpen(undefined)}
              >
                Agregar
              </Button>
            </Tooltip>
            <Tooltip title="Clonar cotización seleccionada">
              <Button
                icon={<CopyOutlined />}
                style={{ fontSize: 13 }}
                onClick={() => {
                  if (selectedRow) {
                    setShowCloneModal(true);
                  } else {
                    message.error("Seleccione una cotización para clonar");
                  }
                }}
              >
                Clonar
              </Button>
            </Tooltip>
            <Tooltip title="Exportar como CSV">
              <Button icon={<ExportOutlined />} style={{ fontSize: 13 }} onClick={handleExport}>
                Exportar
              </Button>
            </Tooltip>
          </Space>

          {/* Mobile actions */}
          <Space size={8} className="vf-mobile-actions" style={{ flexShrink: 0 }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              style={{ fontSize: 13, fontWeight: 500 }}
              onClick={() => handleCotizacionFormOpen(undefined)}
            >
              Agregar
            </Button>
            <Dropdown overlay={<Menu items={mobileMenuItems} />} trigger={["click"]} placement="bottomRight">
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Space>
        </div>

        {/* Search row */}
        <div style={{ padding: "12px 20px" }}>
          <Input.Search
            placeholder="Buscar por solicitante…"
            onSearch={(value) => setSearch(value)}
            onChange={(e) => {
              if (!e.target.value) setSearch("");
            }}
            allowClear
            loading={loading}
            style={{ maxWidth: 380 }}
          />
        </div>
      </div>

      {/* ── Table card ── */}
      <div style={{ ...CARD, overflow: "hidden", padding: "8px", fontSize: "13px" }}>
        <Table
          size="small"
          rowKey={(record) => record.CotizacionID}
          columns={columns}
          dataSource={search ? filteredCotizaciones : cotizacionesList}
          loading={loading}
          onChange={(pagination, filters, sorter, extra) => {
            setCurrentData(extra.currentDataSource);
          }}
          rowSelection={{
            type: "radio",
            onSelect: (record) => {
              setSelectedRow(record.CotizacionID);
            },
            selectedRowKeys: [selectedRow],
          }}
          pagination={{
            defaultPageSize: 25,
            showSizeChanger: true,
            showLessItems: true,
            pageSizeOptions: ["10", "25", "50", "100"],
          }}
          scroll={{
            x: "max-content",
          }}
        />
      </div>

      {/* Responsive Styles */}
      <style>{`
        .vf-mobile-actions  { display: none !important; }
        .vf-desktop-actions { display: flex !important; }
        @media (max-width: 600px) {
          .vf-mobile-actions  { display: flex !important; }
          .vf-desktop-actions { display: none !important; }
        }
      `}</style>
      <CotizacionesForm
        visible={showCotizacionesModal}
        onCancel={handleCotizacionFormCancel}
        setCotizacionesList={fetchCotizaciones}
        record={selectedCotizacion}
        isNew={isNew}
      />
      <Modal
        title="Eliminar cotización"
        visible={showDeleteModal}
        onOk={() => handleDeleteCotizacion(selectedCotizacion)}
        onCancel={() => setShowDeleteModal(false)}
      >
        <p>¿Está seguro de eliminar la cotización?</p>
      </Modal>
      <Modal
        title="Clonar cotización"
        visible={showCloneModal}
        onOk={() => handleCloneCotizacion()}
        onCancel={() => setShowCloneModal(false)}
      >
        <p>¿Está seguro de clonar la cotización?</p>
      </Modal>
    </div>
  );
}
